module.exports = __webpack_public_path__ + "img/744.92290d5c.jpg";